import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ReservationService } from "../../../../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../../../../services/shared/error-handler.service";
import { UserServiceService } from "../../../../services/user-service/user-service.service";
import { ClaimService } from "../../claim.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import {
  etaNonTacableTaxTypes,
  etaTaxSubtypes,
  etaTaxTypes,
} from "../../../../../assets/eta-taxes-info";
import swal from "sweetalert2";

@Component({
  selector: "app-add-claim-form-modal",
  templateUrl: "./add-claim-form-modal.component.html",
  styleUrls: ["./add-claim-form-modal.component.css"],
})
export class AddClaimFormModalComponent implements OnInit {
  @Output() onSave = new EventEmitter();

  @ViewChild("modalRef") modalRef;
  @Input("payments") payments;

  // data
  claim_id = null;
  reservation_id = null;

  // lists
  types_list = [
    {
      id: "marketing fees",
      name: "Marketing Fees",
    },
    {
      id: "maintenance difference",
      name: "Maintenance Difference",
    },
    {
      id: "other_maintenance",
      name: "Other Maintenance",
    },
    {
      id: "water",
      name: "Water",
    },
    {
      id: "electricity",
      name: "Electricity",
    },
    {
      id: "revenue share",
      name: "Revenue Share",
    },
    {
      id: "penalty",
      name: "Penalty",
    },
    {
      id: "golf_car",
      name: "Golf Car",
    },
    {
      id: "other",
      name: "Other",
    },
  ];

  // -- fetched
  banks_list = [];
  store_banks_list = [];

  // form
  formData;

  developers;
  items;

  tax_types = [...etaTaxTypes, ...etaNonTacableTaxTypes];
  tax_subtypes = etaTaxSubtypes;
  tax_sub_types_match = [];

  constructor(
    private claimService: ClaimService,
    private reservationService: ReservationService,
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService
  ) {}

  ngOnInit() {
    this.getdevelopers();
    this.getStoreBanks();
    this.getBanks();
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        //console.log(this.developers);
        // this.getETAForDeveloper(this.developer_id, this.view);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBanks() {
    this.reservationService.getbanks().subscribe(
      (res: any) => {
        this.banks_list = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getStoreBanks() {
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  public open(reservation_id, edit_id) {
    this.reservation_id = reservation_id;
    if (edit_id) {
      this.claim_id = edit_id;
      this.getClaim();
    } else {
      this.formData = {
        type: null,
        other: "",

        from_date: "",
        to_date: "",

        due_date: "",

        amount: "",
        taxes_percentage: "",

        cheque_number: "",

        bank_id: "",
        store_status: "",

        claim_text: "",
        payment_id: "",
      };
    }

    this.modalRef.open();
  }

  getClaim() {
    this.claimService.getClaim(this.claim_id).subscribe((res) => {
      let is_type = this.types_list.find((t) => t.id == res.type);
      this.formData = {
        type: is_type ? res.type : "other",
        other: is_type ? "" : res.type,

        from_date: res.from_date,
        to_date: res.to_date,

        due_date: res.due_date,

        amount: res.amount_before_taxes,
        taxes_percentage: res.taxes_percentage,

        cheque_number: res.cheque_number,

        bank_id: res.bank_id,
        store_status: res.store_status,

        claim_text: res.claim_text,

        partially_method: res.partially_method,
        transaction_number: res.transaction_number,
      };
    });
  }

  save() {
    const payload: any = {
      ...this.formData,
      type:
        this.formData.type === "other"
          ? this.formData.other
          : this.formData.type,
      from_date: this.formData.from_date,
      to_date: this.formData.to_date,
      due_date: this.formData.due_date,
      amount: this.formData.amount,
      taxes_percentage: this.formData.taxes_percentage,
      cheque_number: this.formData.cheque_number,
      bank_id: this.formData.bank_id,
      store_status: this.formData.store_status,
      claim_text: this.formData.claim_text,
      payment_id: this.formData.payment_id,
    };
    if (this.claim_id) {
      payload.id = this.claim_id;
    }
    this.claimService
      .storeClaim(this.reservation_id, payload)
      .subscribe(
        (res) => {
          this.onSave.emit();
          this.modalRef.close();
          swal("Success", "Claim addedd successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {});
  }

  calculateAmount() {
    let payload;
    if (
      this.formData.type === "marketing fees" &&
      this.formData.from_date &&
      this.formData.to_date &&
      this.formData.num_fees
    ) {
      payload = {
        type: this.formData.type,
        from_date: this.formData.from_date,
        to_date: this.formData.to_date,
        num_fees: this.formData.num_fees,
      };
    } else if (
      this.formData.type === "maintenance difference" &&
      this.formData.from_date &&
      this.formData.to_date &&
      this.formData.indoor_meter_maintenance_difference &&
      this.formData.outdoor_meter_maintenance_difference
    ) {
      payload = {
        type: this.formData.type,
        from_date: this.formData.from_date,
        to_date: this.formData.to_date,
        indoor_meter_maintenance_difference:
          this.formData.indoor_meter_maintenance_difference,
        outdoor_meter_maintenance_difference:
          this.formData.outdoor_meter_maintenance_difference,
      };
    } else {
      return;
    }

    this.claimService
      .calcClaimAmount(this.reservation_id, payload)
      .subscribe(
        (res) => {
          if (!isNaN(+res.amount)) {
            this.formData.amount = +res.amount;
          }
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {});
  }

  onDeveloperChange(event, row) {
    this.formData.item = null;
    this.items = null;
    if (this.formData.developer_id) {
      this.items = this.developers.find(
        (developer) => developer.id == this.formData.developer_id
      ).items;
    }
  }

  onGetTaxTypeChange() {
    //console.log(this.tax_subtypes);
    //console.log(this.formData.tax_type);
    this.formData.tax_sub_type = null;
    this.tax_sub_types_match = this.tax_subtypes.filter(
      (type: any) => type.taxtypeReference == this.formData.tax_type
    );
    //console.log(this.tax_sub_types_match);
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/modals/add-claim-form-modal/add-claim-form-modal.component.ts